/** Soil types in lowercase */
type SoilType = 'nccpi' | 'csr2' | 'cpi' | 'pi';

/** Soil types in uppercase */
export type SoilIndex =
  | 'NCCPI'
  | 'PI'
  | 'CSR2'
  | 'CPI'
  | 'corn_bu_ac'
  | 'WAPI'
  | 'STORIE';

/**
 * Human Readable version of SoilIndex, use to display to user
 */
export const SoilIndexHumanReadable: Record<SoilIndex, string> = {
  CPI: 'CPI',
  CSR2: 'CSR2',
  NCCPI: 'NCCPI',
  PI: 'PI',
  STORIE: 'Storie',
  WAPI: 'WAPI',
  corn_bu_ac: 'corn_bu_ac',
};

export default SoilType;
